import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { UPLOADS_BASE_URL } from "../context/AuthContext";

export default function CardComponent(props) {
  const { backgroundColor = "#fff", image, title, text } = props;

  const resolvedImage = image ? (
    image.startsWith('http') || image.startsWith('data:')
      ? image
      : (image.startsWith('images/') || image.startsWith('/images/'))
        ? (image.startsWith('/') ? image : `/${image}`)
        : `${UPLOADS_BASE_URL}/${image.replace(/^\//, '')}`
  ) : null;

  return (
    <Card sx={{
      backgroundColor: backgroundColor,
      borderRadius: "24px",
      boxShadow: "none",
    }}>
      {resolvedImage && (
        <CardMedia component="img" alt={title || ""} height="350" image={resolvedImage} />
      )}
      <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
        {title && (
          <Typography gutterBottom variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 2 }}>
            {title}
          </Typography>
        )}
        {text && (
          typeof text === 'string' ? (
            <Typography 
              variant="body1" 
              component="div" 
              sx={{ 
                whiteSpace: 'pre-line', 
                lineHeight: 1.7,
                color: 'text.primary',
                '& blockquote': {
                  pl: 2, ml: 0, my: 1.5,
                  borderLeft: '4px solid #ccc',
                  fontStyle: 'italic'
                },
                '& ul': { pl: 2.5, my: 1 },
                '& mark': { bgcolor: '#FFF176', px: 0.5, borderRadius: 0.5 }
              }}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          ) : (
            <Box sx={{ color: 'text.primary' }}>
              {text}
            </Box>
          )
        )}
      </CardContent>
    </Card>
  );
}